<div id="userProfileDetail" class="ya-typography" (swiperight)="SwiperNavigateBack()">
  <ya-subheader [hasContent]="true"></ya-subheader>
  <div class="ya-page-content ya-page-content--webshop ya-page-content--inset ya-page-content--aligncenter">
    <div class="description">
      <h2 langkey="phMenuService_Choice"></h2>
      <p langkey="phMenuService_PlsChooseService_TEXT"></p>
    </div>
    <ng-container *ngIf="ordertypes">
      <div [@serviceButtonEntering]="ordertypes" class="menu-service-item-container">
        <ng-container *ngFor="let ordertype of ordertypes">
          <div a11y_Button class="choice ya-icon-button service-button" (click)="checkService(ordertype.id)">
            <div class="icon-container">
              <div class="inline-icon" inlineSVG="{{ordertype.iconFilename}}"></div>
            </div>
            <div class="content-container">
              <h2 class="title">{{ordertype.label}}</h2>
              <div class="text content-container--subfont">{{ordertype.description}}</div>
            </div>
          </div>
        </ng-container>
      </div>
      </ng-container>
  </div>
</div>